module.exports = __webpack_public_path__ + "img/ic-balance.158b3672.svg";